<template lang="pug">
aside(
    :class="styles.root"
)
    div(
        :class="styles.header"
    )
        p(
            :class="styles.title"
        ) Настройки 
        div(
            :class="styles.controls"
        )
            button(
                :class="styles.button"
                @click="close"
            )
    div(
        :class="styles.content"
    )
        div(
            :class="styles.row"
        )
            p(
                :class="styles.category"
            ) Theme:
            div(
                :class="styles.list"
            )
                Radio(
                    :value="theme"
                    id="light"
                    @input="onInputTheme"
                ) Light
                Radio(
                    :value="theme"
                    id="dark"
                    @input="onInputTheme"
                ) Dark
        div(
            :class="styles.row"
        )
            p(
                :class="styles.category"
            ) State:
            div(
                :class="styles.list"
            )
                Radio(
                    :value="state.kind"
                    id="idle"
                    @input="onInputState"
                ) Idle
                Radio(
                    :value="state.kind"
                    id="loading"
                    @input="onInputState"
                ) Loading
                Radio(
                    :value="state.kind"
                    id="invalid-state"
                    @input="onInputState"
                ) Invalid-state
                Radio(
                    :value="state.kind"
                    id="resolved"
                    @input="onInputState"
                ) Resolved
                Radio(
                    :value="state.kind"
                    id="rejected"
                    @input="onInputState"
                ) Rejected
                Radio(
                    :value="state.kind"
                    id="api-fail"
                    @input="onInputState"
                ) Api fail
                Radio(
                    :value="state.kind"
                    id="expired"
                    @input="onInputState"
                ) Expired
</template>

<script lang="ts">
import Vue, { useCssModule } from 'vue'

import { useDebug } from '@/app/Debug/model'
import { Radio } from '@/app/Debug/Radio'

import { Theme, useTheme } from '@/shared/lib/model'
import { Kind, useAppStore } from '@/shared/model'
import { useIsOnlyQrLayout } from '@/shared/lib/hooks/useIsOnlyQrLayout'

export default Vue.extend({
    name: 'Debug',
    setup() {
        const styles = useCssModule()
        const { close } = useDebug()
        const { theme, setTheme } = useTheme()
        const { state } = useAppStore()
        const { isOnlyQrLayout } = useIsOnlyQrLayout()

        function onInputTheme(e: Theme) {
            setTheme(e)
        }

        function onInputState(e: Kind) {
            state.kind = e
        }

        return {
            styles,
            close,
            theme,
            onInputTheme,
            state,
            onInputState,
            isOnlyQrLayout,
        }
    },
    components: { Radio },
})
</script>

<style module lang="scss" src="./Debug.module.scss" />
